import { useEffect } from "react";

// px, absorbs sub-pixel gaps between sections
const GAP_TOLERANCE = 2;

export function LogoMask(wpContent) {
  useEffect(() => {
    // *** Le setup *__*
    const altLogo = document.getElementById("logo-dark");
    const logoMask = document.getElementById("logo-mask");
    const mainSections = [...document.querySelectorAll("main > section")];
    const altSections = document.querySelectorAll(".page-yellow");
    function isYellow(section) {
      return section.classList.contains("page-yellow");
    }

    if (!altLogo || !logoMask || !altSections.length) return;

    // Get logo bounds
    function getLogoBounds() {
      const rect = altLogo.getBoundingClientRect();
      return {
        top: rect.top,
        bottom: rect.bottom,
        height: rect.height,
      };
    }

    // Walks the sections top to bottom and returns the yellow ones as { top, bottom } bands, with touching sections collapsed into one band.
    function yellowRuns() {
      const runs = [];
      for (const section of mainSections) {
        if (!isYellow(section)) continue;
        const rect = section.getBoundingClientRect();
        const current = runs[runs.length - 1];
        if (current && rect.top - current.bottom <= GAP_TOLERANCE) {
          current.bottom = Math.max(current.bottom, rect.bottom);
        } else {
          runs.push({ top: rect.top, bottom: rect.bottom });
        }
      }
      return runs;
    }

    // Single-pass update: evaluates every yellow run at once to determine the correct mask position regardless of scroll speed.
    function updateMask() {
      // Update logo bounds, because it's got position:sticky
      const { top, bottom, height } = getLogoBounds();

      let covering = null;
      let maxOverlap = 0;
      let runAbove = false; // a yellow run has already been passed

      for (const run of yellowRuns()) {
        const overlap =
          Math.min(run.bottom, bottom) - Math.max(run.top, top);

        if (overlap > 0) {
          if (overlap > maxOverlap) {
            maxOverlap = overlap;
            covering = run;
          }
        } else if (run.bottom <= top) {
          runAbove = true;
        }
      }

      if (covering) {
        const hidden = height - Math.min(height, maxOverlap);
        const leavingUp = covering.bottom <= bottom;

        logoMask.setAttribute("y", leavingUp ? -hidden : hidden);
      } else if (runAbove) {
        // Settled state: yellow run fully passed above — mask has exited top
        logoMask.setAttribute("y", -height);
      } else {
        // Settled state: no yellow run reached yet — mask hidden below
        logoMask.setAttribute("y", height);
      }
    }

    updateMask();

    let rafId = null;
    function handleScroll() {
      if (rafId) return;
      rafId = requestAnimationFrame(() => {
        updateMask();
        rafId = null;
      });
    }
    document.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleScroll);

    return () => {
      document.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
      if (rafId) cancelAnimationFrame(rafId);
    };
  }, [wpContent]);
}
